import { siteUrl } from '@config'
import { withDisplayName } from '@hocs/with-display-name'
import { SEO_IDS } from '@meta/constants'
import { MetaDescription } from '@meta/meta-description'
import { MetaImage } from '@meta/meta-image'
import { MetaTitle } from '@meta/meta-title'
import { graphql } from 'gatsby'
import React from 'react'

import { StructuredData } from '../structured-data/structured-data'

const ContentfulSeo: Utils.EntryFC<Queries.ContentfulSeoFragment> = ({
  content,
}) => {
  const {
    title,
    description,
    image,
    robots,
    canonicalRef,
    customStructuredData,
  } = content || {}
  const data = customStructuredData?.internal?.content
  return (
    <>
      <MetaTitle title={title} />
      <MetaDescription description={description?.text} />
      <MetaImage title={image?.title} url={image?.file?.url} />
      {robots && (
        <meta content={robots.join(', ')} id={SEO_IDS.ROBOTS} name="robots" />
      )}
      {canonicalRef && (
        <link
          href={`${siteUrl}${canonicalRef.pageUrl}`}
          id={SEO_IDS.CANONICAL}
          rel="canonical"
        />
      )}
      {data && <StructuredData data={data} />}
    </>
  )
}

export const query = graphql`
  fragment ContentfulSeo on ContentfulSeo {
    ...ContentfulEntry
    title
    robots
    canonicalRef {
      ... on Contentful3TUjMz7TxKWiQYygwIysig {
        pageUrl
      }
    }
    description {
      text
    }
    image {
      ...ContentfulDefaultAsset
    }
    customStructuredData {
      internal {
        content
      }
    }
  }
`

export default withDisplayName(ContentfulSeo, 'ContentfulSeo')
